import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IDocumentTypesDto } from "app/main/pages/documents/dto/document-listing.dto";
import { HttpActionState } from "app/main/pages/users/userslisting/store/users-listing.reducers";
import { map, Observable } from "rxjs";
import * as DocumentTypeActions from "./document-type.actions";
import * as DocumentTypeSelectors from "./document-type.selectors";
import { IMetadataItemDto } from "../../documentfields/metadata-item.dto";


@Injectable({
    providedIn: 'root'
})


export class DocumentTypeFacade { 

    public selectDocumentTypeLayoutSettings$: Observable<IDocumentTypesDto> = this._store.select(DocumentTypeSelectors.selectDocumentTypeLayoutSettings);
    public documentTypeLayoutSettingsRequestState$: Observable<HttpActionState> = this._store.select(DocumentTypeSelectors.selectFetchDocumentTypeLayoutSettingsRequestState);
    public selectMetaDataFields$: Observable<IMetadataItemDto[]> = this._store.select(DocumentTypeSelectors.selectMetaDataFields);
    public selectMetaDataFieldsRequestState$: Observable<HttpActionState> = this._store.select(DocumentTypeSelectors.selectFetchMetaDataFieldsRequestState);
    public updateLayoutSettingsRequestState$: Observable<boolean> = this._store.select(DocumentTypeSelectors.selectUpdateLayoutSettingsRequestState).pipe(map(x => x === HttpActionState.Busy));
    public updateLayoutSettingsState$: Observable<HttpActionState> = this._store.select(DocumentTypeSelectors.selectUpdateLayoutSettingsRequestState);
    public updateDocumentTypeSelectorRequestState$: Observable<boolean> = this._store.select(DocumentTypeSelectors.selectUpdateDocumentTypeSelectorRequestState);

    constructor (private _store: Store) { }



    /**
     * Dispatches an action to fetch the layout settings for a specific document type.
     *
     * @param id - The unique identifier of the document type whose layout settings are to be fetched.
     */
    fetchDocumentTypeLayoutSettings(id: number): void {
        this._store.dispatch(DocumentTypeActions.fetchDocumentTypeLayoutSettings({ id }));
    }



    /**
     * Updates the document type layout settings in the application state.
     *
     * Dispatches an action to update the layout settings for a document type
     * using the provided settings data transfer object.
     *
     * @param layoutSettings - The layout settings to be updated, represented by an `IDocumentTypesDto` object.
     */
    updateLayoutSettingsInState(layoutSettings: IDocumentTypesDto): void {
        this._store.dispatch(DocumentTypeActions.updateDocumentTypeLayoutSettingsInState({ layoutSettings }));
    }


    /**
     * Dispatches an action to fetch metadata related to document types.
     *
     * This method triggers the `fetchMetaData` action in the store, which is typically
     * used to retrieve metadata information required for document type management.
     */
    fetchMetaDataFields(): void {
        this._store.dispatch(DocumentTypeActions.fetchMetaDataFields());
    }
    


    /**
     * Dispatches an action to update the layout settings for document types.
     *
     * @param layoutSettings - The new layout settings to be applied, represented by an `IDocumentTypesDto` object.
     */
    updateLayoutSettings(layoutSettings: IDocumentTypesDto): void {
        this._store.dispatch(DocumentTypeActions.updateLayoutSettings({ layoutSettings }));
    }




    /**
     * Dispatches an action to update the document type selector for a specified context.
     *
     * @param selector_for - The identifier or context for which the document type selector should be updated.
     */
    updateSelectorForSetting(selector_for: string): void {
        this._store.dispatch(DocumentTypeActions.updateDocumentTypeSelector({ selector_for }));
    }
}